var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { State } from "../features/info/event/reducerEventInfo";
import { utilTime } from "./utilTime";
var UtilEvent = /** @class */ (function () {
    function UtilEvent() {
        var _this = this;
        this.getEndTime = function (event) {
            return event.proto && event.proto.startTime !== undefined && event.proto.duration !== undefined
                ? event.proto.startTime + utilTime.secondsToMs(event.proto.duration)
                : undefined;
        };
        this.timestampModifier = function (events) {
            return events
                .map(function (event) {
                var startTime = utilTime.remainingTimeToTimestamp(event.startTime);
                var endTime = startTime + utilTime.secondsToMs(event.duration || 0);
                var state = utilTime.secondsLeftTill(startTime) > 0
                    ? State.PENDING
                    : utilTime.secondsLeftTill(endTime) > 0
                        ? State.STARTED
                        : State.ENDED;
                return __assign({}, event, { startTime: startTime,
                    state: state });
            })
                .sort(_this.sortEvents);
        };
        this.removeEventByIdModifier = function (id) { return function (events) {
            return events.filter(function (event) { return event.eventId !== id; }).sort(utilEvent.sortEvents);
        }; };
        this.startEventByIdModifier = function (id) { return function (events) {
            return events
                .map(function (event) { return (event.eventId !== id ? event : __assign({}, event, { state: State.STARTED })); })
                .sort(utilEvent.sortEvents);
        }; };
        this.sortEvents = function (a, b) {
            return a.startTime - b.startTime;
        };
    }
    return UtilEvent;
}());
export var utilEvent = new UtilEvent();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilEvent.ts
// module id = 248
// module chunks = 3